import { render, staticRenderFns } from "./ViewWasteRequest.vue?vue&type=template&id=7b3894d6&"
import script from "./ViewWasteRequest.vue?vue&type=script&lang=js&"
export * from "./ViewWasteRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports